module.exports = __webpack_public_path__ + "img/Group 3.96920b70.png";